export default {"src":"/login-app/[GIT_HASH]/_next/static/media/help_circle.67c2616c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};